export const HEADER_AUTH_HINT_COOKIE = 'julius_header_auth';
export const HEADER_AUTH_HINT_VALUE = '1';
export const AUTH0_STORAGE_KEY_PREFIX = '@@auth0spajs@@';

export const isAuthCookieName = (name: string) => name.toLowerCase().includes('auth0');

export const hasHeaderAuthHintCookie = (cookies: { name: string; value?: string }[]) =>
  cookies.some(
    (cookie) =>
      cookie.name === HEADER_AUTH_HINT_COOKIE && cookie.value === HEADER_AUTH_HINT_VALUE
  );
